import apiService from './api';

export interface Ads {
  id: number;
  image_url: string;
  user_id: string;
  company_id: string;
  created_at: string;
  updated_at: string;
}

export interface CreateAdsData {
  file_url: string;
}


const adsService = {
  // Get all instructions (admin only)
  getAll: async (): Promise<Ads[]> => {
    const response = await apiService.get<Ads[]>('/get-settings/ads');
    return response.data;
  },

  // Create new instruction (admin only)
  create: async (data: FormData): Promise<Ads> => {
    const response = await apiService.post<Ads>('/ads/upload', data, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  // Delete instruction (admin only)
  delete: async (id: number): Promise<void> => {
    await apiService.delete(`/ads/${id}`);
  },
};

export default adsService; 